<template>
  <div>
    <v-select
      v-model="newselectedValueOption"
      :reduce="(data_option) => data_option.code"
      :options="data_option"
      @search="fetchOptions"
      @input="selectedOption"
      @search:focus="MyFocus"
      :label="'name'"
    >
    </v-select>
  </div>
</template>

<script>
import UserService from '../../services/user.service';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
var debounce = require('debounce');
export default {
  name: 'Select2SearchWithTokenPrefetch',
  props: ['remoteControl','selectedOptionArray'],
  components: {
    vSelect,
  },
  data() {
    return {
      data_option: [],
      newselectedValueOption: {},
    };
  },
  mounted(){
    if(Object.keys(this.selectedOptionArray).length !== 0){
      this.newselectedValueOption = this.selectedOptionArray
    }

  },
  created(){
    // this.fetchOptions('a',true)
    //this.searchVal('a', loading(true), this.remoteControl, this);
    
  this.preSearchVal("",this.remoteControl, this);
  },
  methods: {
    MyFocus(){
      if(this.data_option.length ==0){
        this.preSearchVal("",this.remoteControl, this);
      }
    },
    selectedOption(value){
      this.$emit('selectedData', value)
    },
    fetchOptions(search, loading) {
      if (search.length) {
        loading(true);
        this.searchVal(search, loading, this.remoteControl, this);
      }
    },
    searchVal: debounce((search, loading, url, vm) => {
      // AJAX request
      var param = {};
      param.search = search;
      UserService.getMetod(url, param).then(function (response) {
        vm.data_option = response.data;
      });
      loading(false);
    }, 350),
     preSearchVal: debounce((search, url, vm) => {
      // AJAX request
      var param = {};
      param.search = search;
      UserService.getMetod(url, param).then(function (response) {
        vm.data_option = response.data;
      });
      
    }, 350),
  },
};
</script>